import { Injectable } from "@angular/core";
import { IUserNotificationService } from "src/app/domain/notifications/interfaces/i-user-notification-service";

@Injectable()
export abstract class IUserNotification extends IUserNotificationService{
  
}
